<template>
    <v-menu v-model="menuIni" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y
        min-width="auto">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field v-bind="attrs" :value="textoVisible"
            @input="$emit('update:value', $event)"
            :label="label" prepend-inner-icon="mdi-calendar" readonly outlined dense color="primary"
            :class="$attrs.class" :height="$attrs.height" :rules="$attrs.rules"
            :error-messages="$attrs['error-messages']" :hint="$attrs.hint" :persistent-hint="!!$attrs.hint"
            :disabled="$attrs.disabled"
                v-on="on"></v-text-field>
        </template>
        <v-date-picker :value="value" @input="onchange" :first-day-of-week="1" locale="es-AR"
            :min="min" :max="max"></v-date-picker>
    </v-menu>
</template>

<script>
    import { formatearFecha } from '@/utils/formatos.js';

    // `min`, `max` y `formatoVisible` son opcionales: sin ellos el campo se
    // comporta exactamente como antes (muestra el valor ISO tal cual).
    export default{
        inheritAttrs: false,
        model : {
            prop : 'value',
            event : 'update:value'
        },
        props: {

            value: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: 'FECHA RESOLUCIÓN'
            },
            /** 'AAAA-MM-DD': los días anteriores quedan deshabilitados en el calendario. */
            min: { type: String, default: undefined },
            max: { type: String, default: undefined },
            /** 'iso' (como siempre) | 'dia-mes-anio' (15/10/2026). El v-model sigue en ISO. */
            formatoVisible: { type: String, default: 'iso' },
        },
        computed: {
            textoVisible() {
                if (this.formatoVisible !== 'dia-mes-anio' || !this.value) return this.value;
                return formatearFecha(this.value);
            },
        },
        emits : ['update:value'],
        data(){
            return {
                menuIni : 0,
            }
        },

        methods: {
            onchange(event){
                this.menuIni = false;
                this.$emit('update:value', event);
            }
        }

    }

</script>

<style scoped>
.campo-texto-azul ::v-deep .v-input__control,
.campo-texto-azul ::v-deep .v-input__slot {
  min-height: 56px !important;
}
.campo-texto-azul ::v-deep fieldset {
  border-color: #002245 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}
.campo-texto-azul ::v-deep input {
  color: #002245 !important;
  font-weight: 600;
}
.campo-texto-azul ::v-deep .v-label {
  color: #002245 !important;
  font-weight: 600;
}
.campo-texto-azul ::v-deep .v-icon {
  color: #002245 !important;
}
</style>